import React from "react";
import { Link, useNavigate } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "./ProjectCard.css";

interface ProjectCardProps {
  title: string;
  descList: string[];
  image: string;
  link?: string;
}

const ProjectCard: React.FC<ProjectCardProps> = ({
  title,
  descList,
  image,
  link,
}) => {
  const navigate = useNavigate();

  return (
    <div className='col-md-6 col-lg-3'>
      <div
        className={`card h-80 shadow-sm project-card brand-card${
          link ? " project-card--interactive" : ""
        }`}
        onClick={() => {
          if (link) {
            navigate(link);
          }
        }}
        onKeyDown={(event) => {
          if (!link) {
            return;
          }

          if (event.key === "Enter" || event.key === " ") {
            event.preventDefault();
            navigate(link);
          }
        }}
        role={link ? "link" : undefined}
        tabIndex={link ? 0 : undefined}
      >
        <div className='project-img-box'>
          <img src={image} alt={title} className='card-img-top project-img' />
        </div>
        <div className='card-body project-card-body'>
          <h5 className='card-title project-card-title'>{title}</h5>
          <ul className='project-card-list mb-0'>
            {descList.map((point) => (
              <li key={`${title}-${point}`} className='project-card-list-item'>
                {point}
              </li>
            ))}
          </ul>
          {link && (
            <div className='project-card-footer'>
              <Link
                to={link}
                className='project-card-view-more'
                onClick={(event) => event.stopPropagation()}
              >
                View More <i className='bi bi-arrow-right-short'></i>
              </Link>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ProjectCard;
